import { Component, OnInit, ViewChild } from '@angular/core';
import { DxFormComponent, DxButtonModule, DxFormModule } from 'devextreme-angular';
import { UserChangePassword } from '../user-change-password';

import { alert } from 'devextreme/ui/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CurrentUserService } from '../current-user.service';


@Component({
  selector: 'ngx-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  @ViewChild(DxFormComponent) form: DxFormComponent
  popupVisible: boolean = false;
  user: UserChangePassword = new UserChangePassword();
  errorMessages: string[];
  loadingVisible = false;

  constructor(private _currentUserService: CurrentUserService, private _translateService: TranslateService) {
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  ngOnInit() {
  }

  show() {
    this.popupVisible = true;
  }

  hide() {
    this.popupVisible = false;
  }

  passwordComparison = () => {
    return this.form.instance.option("formData").NewPassword;
  }

  onFormSubmit = function (e) {
    var validated = this.form.instance.validate();
    if (validated.isValid) {
      this.loadingVisible = true;
      this._currentUserService.changePassword(this.user).subscribe({
        next: data => {
          alert(this._translateService.instant('WACHTWOORD_WIJZIGEN.SUCCESVOL_TEKST'), this._translateService.instant('WACHTWOORD_WIJZIGEN.SUCCESVOL_TITEL')).then(data => {
            this.popupVisible = false;
            this.loadingVisible = false;
          });
        },
        error: error => {
          this.loadingVisible = false;
          this.errorMessages = error.error;
        }
      });
    }
  }

}
